import { render, staticRenderFns } from "./WechatTip.vue?vue&type=template&id=6621c06b&scoped=true&"
import script from "./WechatTip.vue?vue&type=script&lang=js&"
export * from "./WechatTip.vue?vue&type=script&lang=js&"
import style0 from "./WechatTip.vue?vue&type=style&index=0&id=6621c06b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621c06b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6621c06b')) {
      api.createRecord('6621c06b', component.options)
    } else {
      api.reload('6621c06b', component.options)
    }
    module.hot.accept("./WechatTip.vue?vue&type=template&id=6621c06b&scoped=true&", function () {
      api.rerender('6621c06b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_eagle_landing/components/WechatTip.vue"
export default component.exports